import React from 'react';
import ColorBends from './ColorBends';
import Iridescence from './Iridescence';
import { COLOR_BENDS_DEFAULT_PROPS } from './heroBackgroundConfig.js';

/**
 * モバイル時は Iridescence、PC 時は ColorBends を表示する共通背景
 * @param {boolean} isMobile
 */
export default function HubBackground({ isMobile }) {
  if (isMobile) {
    return <Iridescence />;
  }
  return <ColorBends {...COLOR_BENDS_DEFAULT_PROPS} />;
}
